import { injectable } from "inversify";
import QARepository from "../../repositories/qa.repository";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/error.entity";
import SearchResultEntity from "../../entities/search_result.entity";
import MasterItemEntity from "../../entities/master_item.entity";

interface _Props {
    qaRepository: QARepository;
}
@injectable()
export default class SearchOperationTypesUseCase {
    private qaRepository: QARepository;
    constructor(props: _Props) {
        this.qaRepository = props.qaRepository;
    }
    public call = async (_: { query: string | undefined, page: number, itemsPerPage: number }): Promise<Either<ErrorEntity, SearchResultEntity<MasterItemEntity>>> => {
        return this.qaRepository.searchOpTypes(_);
    }
}

export const SearchOperationTypesUseCaseName = "SearchOperationTypesUseCase";